// extracted by mini-css-extract-plugin
export default {"search":"search__ikOjb","__size-small":"__size-small__esae3","__size-default":"__size-default__YCowf","__size-accent":"__size-accent__EuQve"};